<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-10-12 17:27:34
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2023-01-05 16:03:13
 * @FilePath: \music\src\components\dialog\code.vue
 * @Description: 
 * 
 * Copyright (c) 2023 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div class="settlement_box">
        <el-dialog :modal-append-to-body="false" custom-class="delCarMusic" :close-on-click-modal="false" title="联系客服"
            :visible.sync="paySuccess" width="540px" :before-close="handleClose">
            <div style="margin-bottom: 20px" v-show="showContract">
                <span>请联系客服获取授权书</span>
            </div>
            <div class="paySuccess">
                <img :src="($env.VUE_APP_URL + $store.state.service)" alt="">
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            paySuccess: false,
            showContract: false,
        }
    },
    methods: {
        handleClose() {
            this.paySuccess = false
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__title {
    font-weight: 600;
}


.paySuccess {
    // width: 1200px;
    // height: 258px;
    background: #FBFBFB;
    text-align: center;
    margin-bottom: 20px;
    opacity: 1;

    // padding: 30px 30px 38px 30px;
    img {
        width: 150px;
        height: 150px;
    }


    h3 {
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 23px;
        margin: 25px 0 20px 0;
    }

    div {
        display: flex;
        // grid-column-gap: 30px;
        margin: auto;
        width: 260px;
        justify-content: space-evenly;

        a {
            color: #D92A20;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #D92A20;
            line-height: 16px;
        }
    }

    p {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        margin-top: 20px;
    }
}
</style>